<template>
  <div class="location" ref="location">
    <div class="location-bg" v-if="!isMobile"></div>
    <div class="container">
      <ego-title :title="title" :subtitle="subtitle" :special="'special'" :theme="'white'" class="location-title"></ego-title>
      <div class="aside-list">
        <div class="top3">
          <img src="./assets/top.png" alt="">
        </div>
        <div class="circle-items">
          <div class="circle-item" v-for="(item, i) in percentList" :key="`circle-${i}`">
            <DrawCanvas :value="item.value" :myCanvas="`myCanvas-${i}`" v-if="showNumAnimation">
              <NumGrow :value="item.value" :time="0.5">%</NumGrow>
            </DrawCanvas>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="tips">
        <div class="item" v-for="(item, id) in locationTips" :key="id">
          <div class="icon-wrap">
            <img class="img" :src="item.icon" alt="" />
          </div>
          <div class="text-wrap">
            <span>{{item.text}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="container">
      <ego-title :title="title" :subtitle="subtitle" :theme="'white'" class="location-title"></ego-title>
      <img src="https://static001-test.geekbang.org/resource/image/e2/08/e26b465aec1f79fbf5c83d5573631a08.png" alt="" v-if="isMobile">
    </div> -->
  </div>
</template>
<script>
import egoTitle from '@/base/ego-title'
import NumGrow from '../../../base/number-grow/number-grow'
import DrawCanvas from './draw-circle'
export default {
  data () {
    return {
      scrollTop: 0,
      showNumAnimation: false,
      percentList: [
        {
          value: 36,
          name: '北京'
        },
        {
          value: 26,
          name: '上海'
        },
        {
          value: 14,
          name: '深圳'
        }
      ]
    }
  },
  components: {
    egoTitle,
    NumGrow,
    DrawCanvas
  },
  props: ['isMobile', 'locationTips'],
  computed: {
    title () {
      return '覆盖全球，精益求精'
    },
    subtitle () {
      if (this.isMobile) {
        return '覆盖 <span style="font-size:18px;color: #D7B375;font-weight: 500">18</span> 个科技发展前沿城市，在 <span style="font-size:18px;color: #D7B375;font-weight: 500">12</span> 个城市举办学习活动，用严谨专业的态度，打造综合实力超群的品质社群'
      } else {
        return '覆盖 <span style="font-size:24px;color: #D7B375;font-weight: 500">18</span> 个科技发展前沿城市，在 <span style="font-size:24px;color: #D7B375;font-weight: 500">12</span> 个城市举办学习活动，用严谨专业的态度，打造综合实力超群的品质社群'
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.listenerScroll)
  },
  methods: {
    listenerScroll () {
      if (this.$refs.location.getBoundingClientRect().top / document.documentElement.clientHeight < 0.5) {
        this.showNumAnimation = true
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.listenerScroll)
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

.location
  position: relative
  height: 960px
  background-color: #0e1014
  +mobile
    background: url('./assets/map-m.png') center / cover no-repeat
    background-color: rgba(0, 0, 0, 1)
    background-position: 0 -20%
    height: 225vw
  .location-bg
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 960px
    background: url('./assets/map-pc.png') center center no-repeat
    background-size: contain
  .container
    height: 100%
    padding-top: 90px
    margin-left: 50%
    transform: translateX(-50%)
    z-index: 100
    +mobile
      padding-top: 40px
    .aside-list
      padding-top: 100px
      +mobile
        padding-top: 35px
      .top3
        width: 179px
        margin-top: -20px
        margin-left: auto
        margin-right: 5px
        margin-bottom: 20px
        +mobile
          width: 120px
        .top
          width: 1000px
        +mobile
          margin: 0 auto
      .circle-items
        +mobile
          display: flex
          justify-content: space-around
      .circle-item
        display: flex
        align-items: center
        margin-left: auto
        margin-bottom: 30px
        width: 180px
        color: #767676
        font-size: 28px
        margin-right: -25px
        +mobile
          width: 30.33%
          margin: 0
        & ::v-deep .draw-circle
          position: relative
          +mobile
            width: 58%
        & ::v-deep .number-grow-warp
          position: absolute
          top: 50%
          left: 50%
          transform: translate(-50%, -50%)
          font-size: 24px
          font-weight: bold
          color: $primary3
          +mobile
            top: 42%
            font-size: 20px
        .name
          margin-left: 30px
          +mobile
            font-size: 14px
            margin-left: 7px
            margin-top: -10px
    .location-title
      width: 85%
      margin: 0 auto
      +mobile
        width: 95%
    .location-button
      margin: 0 auto
    .tips
      position: absolute
      bottom: 80px
      width: 100%
      margin: 0 auto
      display: flex
      justify-content: center
      +mobile
        display: block
        bottom: 30px
        left: 50%
        margin-left: -42.4%
        width: 84.8%
      .item
        display: flex
        color: #fff
        box-shadow: 0 10px 30px 0 rgba(0,0,0,.3)
        +mobile
          margin-bottom: 10px
        .icon-wrap
          width: 90px
          height: 90px
          background: #191b1f
          text-align: center
          display: flex
          align-items: center
          justify-content: center
          +mobile
            height: 50px
            width: 65px
          .img
            // width: 37px
            height: 33px
            +mobile
              height: 20px
              // width: 20px
        .text-wrap
          display: flex
          justify-content: center
          width: 280px
          height: 90px
          background: #1e2328
          font-size: 16px
          line-height: 90px
          padding-left: 9px
          +mobile
            height: 50px
            font-size: 12px
            line-height: 50px
            width: 100%
      .item:nth-child(2)
        margin: 0 20px
        +mobile
          margin: 0 0 10px
@media screen and (max-width: 1440px)
  .location .location-bg
    background-size: cover
</style>
